import type { UnionTypeLibelle } from '../../../techniques'

export const NatureFrais = [
  'Pedagogique',
  'JuryFraisCertification',
  'Autres',
  'LivrableOfa',
  'Hebergement',
  'Repas',
  'PremierEquipement',
  'MobiliteInternationale',
  'Divers',
  'MajorationTravailleurHandicape',
  'Transport',
  'ReperageAcquis',
  'EvaluationCompetences',
  'EvaluateurEntreprise',
  'BilanEvaluationInitiale',
  'EvaluationIntermediaireFinale',
  'CoutJuryFraisCertification',
  'IngenieriePrestationFraisAudit',
  'FraisGarde',
  'AchatMateriel',
  'Remuneration',
  'Diagnostic',
  'Prestations',
] as const

export type NatureFrais = (typeof NatureFrais)[number]

export const BaseCalculFrais = ['Quantite', 'Montant'] as const
export type BaseCalculFrais = (typeof BaseCalculFrais)[number]

export const BaseCalculFraisLibelle: UnionTypeLibelle<BaseCalculFrais> = {
  Quantite: 'Quantité',
  Montant: 'Montant',
} as const

export const ModeFrais = ['Pedagogique', 'Annexe'] as const

export type ModeFrais = (typeof ModeFrais)[number]

export const ModeFraisLibelle: UnionTypeLibelle<ModeFrais> = {
  Pedagogique: 'Pédagogique',
  Annexe: 'Annexe',
} as const
